<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="商品编号">
              <a-input placeholder="请输入商品编号" v-model="queryParam.prodCode"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="商品名称">
              <a-input placeholder="请输入商品名称" v-model="queryParam.prodName"></a-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="商品品类">
                <j-multi-select-tag v-model="queryParam.prodType" placeholder="请选择发布渠道" dictCode="manufacture_product_category,name,id"/>
              </a-form-item>
            </a-col>
<!--            <a-col :xl="6" :lg="7" :md="8" :sm="24">-->
<!--              <a-form-item label="商品规格">-->
<!--                <j-multi-select-tag placeholder="请选择商品规格" dictCode="manufacture_product_category,name,id" v-model="queryParam.prodSpecs"/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="商品状态">
                <j-dict-select-tag placeholder="请选择商品状态" v-model="queryParam.prodState" dictCode="dict_item_status"/>
              </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="myHandleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('商品管理')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        class="j-table-force-nowrap"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="uploadFile(text)">
            下载
          </a-button>
        </template>

        <a slot="FormNoLink" @click="myHandleDetail(record)" slot-scope="text, record">{{text}}</a>

        <span slot="action" slot-scope="text, record">
          <a @click="myHandleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <manufactureProduct-modal ref="modalForm" @ok="modalFormOk"></manufactureProduct-modal>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import ManufactureProductModal from './modules/ManufactureProductModal'
  import JDictSelectTag from '@/components/dict/JDictSelectTag'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import JMultiSelectTag from '@/components/dict/JMultiSelectTag'
  import JTreeSelect from "@/components/jeecg/JTreeSelect"
  // import '@/assets/less/TableExpand.less'

  export default {
    name: "ManufactureProductList",
    mixins:[JeecgListMixin],
    components: {
      JDictSelectTag,
      JMultiSelectTag,
      JTreeSelect,
      ManufactureProductModal
    },
    data () {
      return {
        description: '商品管理管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'商品编号',
            align:"center",
            width:100,
            dataIndex: 'prodCode',
            scopedSlots: { customRender: 'FormNoLink' }
          },
          {
            title:'商品名称',
            align:"center",
            dataIndex: 'prodName'
          },
          {
            title:'商品品类',
            align:"center",
            dataIndex: 'prodType_dictText'
          },
          // {
          //   title:'商品规格',
          //   align:"center",
          //   dataIndex: 'prodSpecs_dictText'
          // },
          // {
          //   title:'商品属性',
          //   align:"center",
          //   dataIndex: 'prodProps_dictText'
          // },
          {
            title:'商品状态',
            align:"center",
            dataIndex: 'prodState_dictText'
          },
          {
            title:'销售价格',
            align:"center",
            dataIndex: 'prodPrice'
          },
          // {
          //   title:'商品图片',
          //   align:"center",
          //   dataIndex: 'prodPic',
          //   scopedSlots: {customRender: 'imgSlot'}
          // },
          // {
          //   title:'创建人',
          //   align:"center",
          //   dataIndex: 'createBy'
          // },
          // {
          //   title:'创建日期',
          //   align:"center",
          //   dataIndex: 'createTime'
          // },
          // {
          //   title:'更新人',
          //   align:"center",
          //   dataIndex: 'updateBy'
          // },
          // {
          //   title:'更新日期',
          //   align:"center",
          //   dataIndex: 'updateTime'
          // },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
        url: {
          list: "/manufacture/manufactureProduct/list",
          delete: "/manufacture/manufactureProduct/delete",
          deleteBatch: "/manufacture/manufactureProduct/deleteBatch",
          exportXlsUrl: "/manufacture/manufactureProduct/exportXls",
          importExcelUrl: "manufacture/manufactureProduct/importExcel",
        },
        dictOptions:{},
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      initDictConfig(){
      },
      myHandleAdd(){
        this.$refs.modalForm.action = 'add';
        this.handleAdd()
      },
      myHandleEdit(record){
        this.$refs.modalForm.action = 'edit';
        this.handleEdit(record)
      },
      myHandleDetail(record){
        this.$refs.modalForm.action = 'detail';
        this.handleDetail(record)
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>